import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=46f52d84"
import script from "./Home.ts?vue&type=script&lang=ts&external"
export * from "./Home.ts?vue&type=script&lang=ts&external"
import style0 from "./home.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports